import { type Component, render } from 'vue'
import { type ComponentProps } from 'vue-component-type-helpers'

import { mount } from '../../utils/mount.ts'
import VConfirm from './VConfirm.vue'

interface ConfirmOptions<TComponent extends Component> {
  component?: TComponent
  componentProps?: ComponentProps<TComponent>
  title?: string
  message?: string
  cancelButtonLabel?: string
  confirmButtonLabel?: string
}

export function $confirm<TComponent extends Component>(options: ConfirmOptions<TComponent> | string) {
  if (typeof options === 'string') {
    options = { message: options }
  }

  return new Promise((resolve, reject) => {
    let { vNode, el } = mount(VConfirm, {
      name: 'VConfirm',
      props: {
        ...(options as ConfirmOptions<TComponent>),
        resolve,
        reject,
        destroy: () => {
          render(null, el)
          el.remove()
          // @ts-expect-error were cleaning up to avoid memory leaks.
          vNode = null
          // @ts-expect-error were cleaning up to avoid memory leaks.
          el = null
        },
      },
    })

    // Set visible ref to true
    if (vNode.component?.exposed) {
      vNode.component.exposed.visible.value = true
    }
  })
}
